<template>
  <transition  name="FADE" mode="out-in">
    <div class="DAY-AGENDA-LIST-ITEM-PLACEHOLDER">
      <span class="x-pulse WIDE-PLACEHOLDER m-b-2" />
      <div class="d-flex">
        <div class="d-flex fd-column">
          <span class="x-pulse PLACEHOLDER" />
          <span class="x-pulse PLACEHOLDER" />
          <span class="x-pulse PLACEHOLDER" />
          <span class="x-pulse PLACEHOLDER" />
        </div>
        <div class="d-flex flex-1-1 fd-column p-l-2">
          <span class="x-pulse PLACEHOLDER" />
          <span class="x-pulse PLACEHOLDER" />
          <span class="x-pulse PLACEHOLDER" />
          <span class="x-pulse PLACEHOLDER" />
        </div>
      </div>
    </div>
  </transition>
</template>
<script>

export default {
  name: 'day-agenda-list-item-placeholder',
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  @import "~@/views/Dashboard/constants";

  .DAY-AGENDA-LIST-ITEM-PLACEHOLDER {
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    min-height: $appointment-list-item-min-height;
    padding: 1*$unit 1*$unit 1*$unit 1 *$unit;
    background-color: white;
    border-bottom: 1px solid $color-gray30;
  }
  .PLACEHOLDER {
    @include rect(74px, 16px);
    margin: $unit/2 0;
  }
  .WIDE-PLACEHOLDER {
    @include rect(250px, 24px);
  }
</style>
